module.exports = __webpack_public_path__ + "static/media/06.274d4ea5.gif";